// Generated by GitHub Copilot
import { Api } from '#core/api/Api.ts'
import MfaFactorList from '#core/entities/auth/mfa/MfaFactorList.ts'

/** The signed-in account's MFA factors, whatever their type; each type is set up through its own API. */
export default class MfaApi extends Api<MfaApi> {
  public static readonly basePath = 'auth/account/me/mfa'

  /** Lists the factors, pending and confirmed; empty for a session that was not signed in with a password. */
  public async listFactors(): Promise<MfaFactorList | null> {
    return this.get<MfaFactorList>(MfaApi.basePath, undefined, MfaFactorList)
  }
}
